import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, MatButtonModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { QuicklinkModule } from 'ngx-quicklink';
import { ErrorMatcher } from '../services/shared/ErrorMatcher';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ExtendViewerComponent } from './extend-viewer/extend-viewer.component';
import { LoadCsvDataComponent } from './load-csv-data/load-csv-data.component';
import { RecoverPasswordDialogComponent } from './recover-password-dialog/recover-password-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentsHelpComponent } from '../inscriptions/documents-help/documents-help.component';

@NgModule({
  imports: [
    CommonModule,
    QuicklinkModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    NgxExtendedPdfViewerModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
  ],
  declarations: [
    LoadCsvDataComponent,
    ExtendViewerComponent,
    ConfirmDialogComponent,
    RecoverPasswordDialogComponent,
    DocumentsHelpComponent
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: ErrorStateMatcher, useClass: ErrorMatcher },
  ],
  exports: [
    QuicklinkModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadCsvDataComponent,
    ExtendViewerComponent,
    ConfirmDialogComponent,
    RecoverPasswordDialogComponent,
  ],
  entryComponents: [
    LoadCsvDataComponent,
    ExtendViewerComponent,
    ConfirmDialogComponent,
    RecoverPasswordDialogComponent,
    DocumentsHelpComponent
  ]
})
export class CommonsModule { }
